var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "properties-field" }, [
    _c("div", { staticClass: "wrap-properties" }, [
      _c("div", { staticClass: "properties-field-title" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("External API")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "close-properties",
            on: {
              click: function($event) {
                _vm.$emit("close-config")
              }
            }
          },
          [_vm._v("\n        ×\n      ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "properties-field-content properties-field-content-config"
        },
        [
          _c(
            "div",
            { staticClass: "section-field input-field" },
            [
              _c("p", { staticClass: "title-section text-capitalize" }, [
                _vm._v("Endpoint " + _vm._s(_vm.typeTab))
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.method.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Method ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              "error-required": _vm.$v.dataSetup.method.$error,
                              options: _vm.methodOptions,
                              placeholder: "Select method",
                              disabled: ["export"].includes(_vm.typeTab),
                              label: "label"
                            },
                            model: {
                              value: _vm.$v.dataSetup.method.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.dataSetup.method, "$model", $$v)
                              },
                              expression: "$v.dataSetup.method.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "b-form",
                        {
                          class: { "error-input": _vm.$v.dataSetup.url.$error }
                        },
                        [
                          _c("label", [_vm._v(" Url ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required": _vm.$v.dataSetup.url.$error,
                              placeholder: "Enter url here"
                            },
                            model: {
                              value: _vm.$v.dataSetup.url.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.dataSetup.url, "$model", $$v)
                              },
                              expression: "$v.dataSetup.url.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-2", attrs: { cols: "12" } },
                    [
                      !["import", "export"].includes(_vm.typeTab)
                        ? _c(
                            "b-form",
                            {
                              class: {
                                "error-input": _vm.$v.dataSetup.source.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Source ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.dataSetup.source.$error,
                                  placeholder: "Enter source here"
                                },
                                model: {
                                  value: _vm.$v.dataSetup.source.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.source,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.dataSetup.source.$model"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-2", attrs: { cols: "12" } },
                    [
                      _vm.typeTab === "list"
                        ? _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.source_count.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Source Count ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.dataSetup.source_count.$error,
                                  placeholder: "Enter source count here"
                                },
                                model: {
                                  value: _vm.$v.dataSetup.source_count.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.source_count,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.dataSetup.source_count.$model"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "title-section mt-4" }, [
                _vm._v("Header")
              ]),
              _vm._v(" "),
              _vm._l(_vm.dataSetup.header, function(data, index) {
                return _c("div", { key: index + 0, staticClass: "form-list" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: data.name,
                        expression: "data.name"
                      }
                    ],
                    staticClass: "name",
                    attrs: { type: "text", placeholder: "Name" },
                    domProps: { value: data.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(data, "name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: data.value,
                        expression: "data.value"
                      }
                    ],
                    staticClass: "value",
                    attrs: { type: "text", placeholder: "Value" },
                    domProps: { value: data.value },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(data, "value", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa fa-trash",
                    on: {
                      click: function($event) {
                        _vm.deleteHeader(index)
                      }
                    }
                  })
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-add-config", on: { click: _vm.addHeader } },
                [_vm._v("\n          + Add Header\n        ")]
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.typeTab === "export"
            ? _c(
                "div",
                { staticClass: "section-field input-field" },
                [
                  _c("p", { staticClass: "title-section" }, [
                    _vm._v("Endpoint Search")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.method_search.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Method ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.dataSetup.method_search.$error,
                                  options: _vm.methodOptions,
                                  placeholder: "Select method",
                                  disabled: true,
                                  label: "label"
                                },
                                model: {
                                  value: _vm.$v.dataSetup.method_search.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.method_search,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.dataSetup.method_search.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "8" } },
                        [
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.url_search.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Url ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.dataSetup.url_search.$error,
                                  placeholder: "Enter url here"
                                },
                                model: {
                                  value: _vm.$v.dataSetup.url_search.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.url_search,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.dataSetup.url_search.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "title-section mt-4" }, [
                    _vm._v("Header")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.header_search, function(data, index) {
                    return _c(
                      "div",
                      { key: index + 0, staticClass: "form-list" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: data.name,
                              expression: "data.name"
                            }
                          ],
                          staticClass: "name",
                          attrs: { type: "text", placeholder: "Name" },
                          domProps: { value: data.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(data, "name", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: data.value,
                              expression: "data.value"
                            }
                          ],
                          staticClass: "value",
                          attrs: { type: "text", placeholder: "Value" },
                          domProps: { value: data.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(data, "value", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash",
                          on: {
                            click: function($event) {
                              _vm.deleteHeaderSearch(index)
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addHeaderSearch }
                    },
                    [_vm._v("\n          + Add Header\n        ")]
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataSetup.method === "GET" &&
          !["import", "export"].includes(_vm.typeTab)
            ? _c(
                "div",
                { staticClass: "section-field input-field" },
                [
                  _c("p", { staticClass: "title-section" }, [_vm._v("Params")]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.params, function(data, index) {
                    return _c(
                      "div",
                      { key: index + 0, staticClass: "form-list" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: data.variable,
                              expression: "data.variable"
                            }
                          ],
                          staticClass: "name",
                          attrs: { type: "text", placeholder: "Variable" },
                          domProps: { value: data.variable },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(data, "variable", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: data.value,
                              expression: "data.value"
                            }
                          ],
                          staticClass: "value",
                          attrs: { type: "text", placeholder: "Value" },
                          domProps: { value: data.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(data, "value", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash",
                          on: {
                            click: function($event) {
                              _vm.deleteParams(index)
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addParams }
                    },
                    [_vm._v("\n          + Add Params\n        ")]
                  )
                ],
                2
              )
            : !["import", "export"].includes(_vm.typeTab)
            ? _c(
                "div",
                { staticClass: "section-field input-field" },
                [
                  _c("p", { staticClass: "title-section" }, [
                    _vm._v("Payload")
                  ]),
                  _vm._v(" "),
                  _vm.showEditor
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c("label", [_vm._v(" Body ")]),
                                  _vm._v(" "),
                                  _c("j-monaco-editor", {
                                    ref: "scriptBody",
                                    attrs: {
                                      value: _vm.dataSetup.payload.body,
                                      height: "200px"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !["import", "export"].includes(_vm.typeTab)
            ? _c("div", { staticClass: "section-field input-field" }, [
                _c(
                  "div",
                  { staticClass: "configuration-section" },
                  [
                    _c("p", { staticClass: "title-section" }, [
                      _vm._v("Parse Variable")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.dataSetup.variable, function(data, index) {
                      return _c(
                        "div",
                        { key: index + 0, staticClass: "div-filter" },
                        [
                          _c("div", { staticClass: "header-filter" }, [
                            _c("div", { staticClass: "index" }, [
                              _vm._v(_vm._s(index + 1))
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-trash",
                              on: {
                                click: function($event) {
                                  _vm.deleteVariable(index)
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            [
                              _c("label", [_vm._v(" Variable ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required": false,
                                  options: _vm.variableOptions,
                                  placeholder: "Select variable"
                                },
                                model: {
                                  value: data.variable,
                                  callback: function($$v) {
                                    _vm.$set(data, "variable", $$v)
                                  },
                                  expression: "data.variable"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            [
                              _c("label", [_vm._v(" Value ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required": false,
                                  placeholder: "Enter value here"
                                },
                                model: {
                                  value: data.value,
                                  callback: function($$v) {
                                    _vm.$set(data, "value", $$v)
                                  },
                                  expression: "data.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-add-config",
                        on: { click: _vm.addVariable }
                      },
                      [_vm._v("\n            + Add Variable\n          ")]
                    )
                  ],
                  2
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "properties-field-button justify-content-end" },
        [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "button",
              {
                staticClass: "button-border mr-2",
                on: {
                  click: function($event) {
                    _vm.$emit("close-config")
                  }
                }
              },
              [_vm._v("\n          Close\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "button-blue", on: { click: _vm.submitForm } },
              [_vm._v("\n          Set\n        ")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce0fa940", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce0fa940","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/ExternalApiForm.vue
// module id = null
// module chunks = 